import EmberObject from '@ember/object';
import Route from 'mewe/routes/route';
import fetchQuests from 'mewe/fetchers/fetch-quests';
import PS from 'mewe/utils/pubsub';

export default Route.extend({

  beforeModel() {
    // get the latest quest state when visiting this page
    fetchQuests();

    // if some quest was completed while this page is open then refetch progress data
    PS.Sub('gamification.quest.completed', fetchQuests);
  },

  model() {
    return EmberObject.create({
      app: this.modelFor('app'),
    });
  },

  actions: {

    willTransition() {
      PS.Unsub('gamification.quest.completed', fetchQuests);
    },

  },
});
